import React, { useState, useEffect } from "react";
import { ReactComponent as ClockIcon } from "./../assets/clock.svg";
import UpperTeethImage from "./../assets/upper_teeth.png";
import LowerTeethImage from "./../assets/lower_teeth.png";
import {
  CHECK_ICON_COLOR,
  DESCRIPTION_COLOR,
  PRIMARY_COLOR,
  TERTIARY_COLOR,
  TEXT_COLOR,
} from "../constants/theme";
import { ReactComponent as PlusIconPrimary } from "./../assets/plus_icon_primary.svg";
import { FaCircleCheck } from "react-icons/fa6";
import { Link, useNavigate } from "react-router";

const TreatmentPlanScreen = () => {
  const [loading, setLoading] = useState(false);
  const [caseDetails, setCaseDetails] = useState({});
  const [screenWidth, setScreenWidth] = useState(0);
  const [countObj, setCountObj] = useState({
    templateUpper: 0,
    templateLower: 0,
    alignerUpper: 0,
    alignerLower: 0,
    retainerUpper: 0,
    retainerLower: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const fetchSetData = async () => {
    setLoading(true);

    let pars = sessionStorage.getItem("case");
    if (!pars) {
      navigate("/cases");
    }
    setCaseDetails(JSON.parse(pars));
    pars = JSON.parse(pars);
    let temp = {
      templateUpper: 0,
      templateLower: 0,
      alignerUpper: 0,
      alignerLower: 0,
      retainerUpper: 0,
      retainerLower: 0,
    };
    if (
      pars?.partial_fabrication?.[0]?.aligners_upper?.filter(
        (item2) => pars.case_id === item2.case_id
      )?.length > 0 ||
      pars?.partial_fabrication?.[0]?.aligners_lower?.filter(
        (item2) => pars.case_id === item2.case_id
      )?.length > 0 ||
      pars?.partial_fabrication?.[0]?.retainers_upper?.filter(
        (item2) => pars.case_id === item2.case_id
      )?.length > 0 ||
      pars?.partial_fabrication?.[0]?.retainers_lower?.filter(
        (item2) => pars.case_id === item2.case_id
      )?.length > 0 ||
      pars?.partial_fabrication?.[0]?.templates_lower?.filter(
        (item2) => pars.case_id === item2.case_id
      )?.length > 0 ||
      pars?.partial_fabrication?.[0]?.templates_upper?.filter(
        (item2) => pars.case_id === item2.case_id
      )?.length > 0
    ) {
      if (
        pars?.partial_fabrication?.[0]?.aligners_upper?.filter(
          (item2) => pars.case_id === item2.case_id
        )?.length > 0
      ) {
        temp.alignerUpper =
          pars?.partial_fabrication?.[0]?.aligners_upper?.filter(
            (item2) => pars.case_id === item2.case_id
          )?.length;
      }

      if (
        pars?.partial_fabrication?.[0]?.aligners_lower?.filter(
          (item2) => pars.case_id === item2.case_id
        )?.length > 0
      ) {
        temp.alignerLower =
          pars?.partial_fabrication?.[0]?.aligners_lower?.filter(
            (item2) => pars.case_id === item2.case_id
          )?.length;
      }

      if (
        pars?.partial_fabrication?.[0]?.retainers_upper?.filter(
          (item2) => pars.case_id === item2.case_id
        )?.length > 0
      ) {
        temp.retainerUpper =
          pars?.partial_fabrication?.[0]?.retainers_upper?.filter(
            (item2) => pars.case_id === item2.case_id
          )?.length;
      }

      if (
        pars?.partial_fabrication?.[0]?.retainers_lower?.filter(
          (item2) => pars.case_id === item2.case_id
        )?.length > 0
      ) {
        temp.retainerLower =
          pars?.partial_fabrication?.[0]?.retainers_lower?.filter(
            (item2) => pars.case_id === item2.case_id
          )?.length;
      }

      if (
        pars?.partial_fabrication?.[0]?.templates_lower?.filter(
          (item2) => pars.case_id === item2.case_id
        )?.length > 0
      ) {
        temp.templateLower =
          pars?.partial_fabrication?.[0]?.templates_lower?.filter(
            (item2) => pars.case_id === item2.case_id
          )?.length;
      }

      if (
        pars?.partial_fabrication?.[0]?.templates_upper?.filter(
          (item2) => pars.case_id === item2.case_id
        )?.length > 0
      ) {
        temp.templateUpper =
          pars?.partial_fabrication?.[0]?.templates_upper?.filter(
            (item2) => pars.case_id === item2.case_id
          )?.length;
      }
    } else {
      if (pars?.aligners_upper_quantity) {
        temp.alignerUpper = pars?.aligners_upper_quantity;
      }
      if (pars?.aligners_lower_quantity) {
        temp.alignerLower = pars?.aligners_lower_quantity;
      }
      if (pars?.retainer_upper_quantity) {
        temp.retainerUpper = pars?.retainer_upper_quantity;
      }
      if (pars?.retainer_lower_quantity) {
        temp.retainerLower = pars?.retainer_lower_quantity;
      }
      if (pars?.template_lower_quantity) {
        temp.templateLower = pars?.template_lower_quantity;
      }
      if (pars?.template_upper_quantity) {
        temp.templateUpper = pars?.template_upper_quantity;
      }
    }
    console.log("TEMP => ", temp);
    setCountObj(temp);

    setLoading(false);
  };

  useEffect(() => {
    fetchSetData();
  }, []);

  // const alignmentHistoryData = [
  //   {
  //     icon: PlusIconPrimary,
  //     iconStyle: {
  //       fill: PRIMARY_COLOR,
  //       height: "100%",
  //       width: "100%",
  //       overflow: "visible",
  //     },
  //     date: "20 SEP",
  //     time: "03:30 AM",
  //     title: "Aligner 5 Replacement",
  //     status: "Pending",
  //   },
  //   {
  //     icon: FaCircleCheck,
  //     iconStyle: {
  //       color: CHECK_ICON_COLOR,
  //       height: "100%",
  //       width: "100%",
  //       overflow: "visible",
  //     },
  //     date: "27 SEP",
  //     time: "10:00 AM",
  //     title: "Aligner 6 Replacement",
  //     status: "Switched",
  //   },
  //   {
  //     icon: FaCircleCheck,
  //     iconStyle: {
  //       color: CHECK_ICON_COLOR,
  //       height: "100%",
  //       width: "100%",
  //       overflow: "visible",
  //     },
  //     date: "01 JUL",
  //     time: "04:45 PM",
  //     title: "Aligner 7 Replacement",
  //     status: "Switched",
  //   },
  // ];

  return (
    <div
      className="container-fluid p-0 position-relative"
      style={{
        overflow: "hidden",
        // backgroundColor: "#fae5ff",
      }}
    >
      <div
        className="position-relative"
        style={{
          // minHeight: "100vh",
          zIndex: "20",
          padding: "2px 15px 10px 15px",
        }}
      >
        <div
          style={{
            backgroundColor: "rgb(255, 255, 255)",
            borderRadius: "15px",
          }}
        >
          <div className="col-12 p-0">
            {caseDetails && caseDetails?.treatment_preview_link ? (
              <iframe
                title={caseDetails.case_id}
                src={caseDetails?.treatment_preview_link}
                height={500}
                width="100%"
              />
            ) : (
              <div
                className="w-100 d-flex align-items-center justify-content-center"
                style={{
                  minHeight: "250px",
                  backgroundColor: "rgb(110, 121, 125)",
                  borderRadius: "15px",
                  color: TERTIARY_COLOR,
                }}
              >
                No preview available
              </div>
            )}
          </div>

          <div
            className=""
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              padding: "16px 13px 28px 13px",
              borderBottomLeftRadius: "15px",
              borderBottomRightRadius: "15px",
            }}
          >
            <div
              className="row w-100 mx-auto flex-column justify-content-start align-items-center"
              style={{
                gap: screenWidth >= 576 ? "28px" : "25px",
              }}
            >
              {/* TOP SECTION */}
              <div className="col-12 p-0">
                <div className="row w-100 mx-auto align-items-center justify-content-center">
                  {/* CENTER AUTO CONTAINER */}

                  <div className="col-auto p-0">
                    <div className="row w-100 mx-auto align-items-center">
                      {/* LABELS LEFT */}

                      <div className="col-auto p-0">
                        <div
                          className=""
                          style={{
                            height: "129px",
                            paddingBottom: "15px",
                          }}
                        >
                          <div className="row mx-auto flex-column justify-content-end h-100">
                            <div className="col-auto p-0">
                              <div
                                className="row mx-auto flex-column align-items-center justify-content-center"
                                style={{
                                  fontSize: "7px",
                                  color: DESCRIPTION_COLOR,
                                  gap: "20.5px",
                                }}
                              >
                                <div className="col-auto p-0" style={{}}>
                                  UPPER
                                </div>
                                <div className="col-auto p-0" style={{}}>
                                  TOTAL
                                </div>
                                <div className="col-auto p-0" style={{}}>
                                  LOWER
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* MIDDLE SECTION */}

                      <div className="col p-0">
                        <div
                          className="row w-100 mx-auto"
                          style={{
                            gap: "10px",
                          }}
                        >
                          <div className="col-auto p-0">
                            <div
                              className="d-flex flex-column align-items-center justify-content-start"
                              style={{
                                gap: "9px",
                              }}
                            >
                              <div
                                className="text-center"
                                style={{
                                  fontSize: "12px",
                                  color: PRIMARY_COLOR,
                                }}
                              >
                                Templates
                              </div>

                              <div
                                className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                style={{
                                  gap: "7px",
                                }}
                              >
                                <div
                                  className="col-auto p-0 position-relative"
                                  style={{}}
                                >
                                  <img
                                    className=""
                                    src={UpperTeethImage}
                                    alt="upper teeth"
                                    style={{
                                      // height: '35px',
                                      width: "38px",
                                    }}
                                  />
                                  <div
                                    className="position-absolute d-flex align-items-end justify-content-center"
                                    style={{
                                      bottom: "0",
                                      width: "100%",
                                      left: "0",
                                      fontSize: "12.5px",
                                      color: DESCRIPTION_COLOR,
                                    }}
                                  >
                                    {countObj?.templateUpper}
                                  </div>
                                </div>

                                <div
                                  className="col-auto p-0"
                                  style={{
                                    color: PRIMARY_COLOR,
                                    fontWeight: "600",
                                    fontSize: "30px",
                                    lineHeight: "1",
                                  }}
                                >
                                  {countObj?.templateUpper +
                                    countObj?.templateLower}
                                </div>

                                <div
                                  className="col-auto p-0 position-relative"
                                  style={{}}
                                >
                                  <img
                                    className=""
                                    src={LowerTeethImage}
                                    alt="upper teeth"
                                    style={{
                                      // height: '30px',
                                      width: "38px",
                                    }}
                                  />
                                  <div
                                    className="position-absolute d-flex align-items-start justify-content-center"
                                    style={{
                                      top: "0",
                                      width: "100%",
                                      left: "0",
                                      fontSize: "12.5px",
                                      color: DESCRIPTION_COLOR,
                                    }}
                                  >
                                    {countObj?.templateLower}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-auto p-0">
                            <div
                              className="d-flex flex-column align-items-center justify-content-start"
                              style={{
                                gap: "9px",
                              }}
                            >
                              <div
                                className="text-center"
                                style={{
                                  fontSize: "12px",
                                  color: PRIMARY_COLOR,
                                }}
                              >
                                Aligners
                              </div>

                              <div
                                className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                style={{
                                  gap: "7px",
                                }}
                              >
                                <div
                                  className="col-auto p-0 position-relative"
                                  style={{}}
                                >
                                  <img
                                    className=""
                                    src={UpperTeethImage}
                                    alt="upper teeth"
                                    style={{
                                      // height: '35px',
                                      width: "38px",
                                    }}
                                  />
                                  <div
                                    className="position-absolute d-flex align-items-end justify-content-center"
                                    style={{
                                      bottom: "0",
                                      width: "100%",
                                      left: "0",
                                      fontSize: "12.5px",
                                      color: DESCRIPTION_COLOR,
                                    }}
                                  >
                                    {countObj?.alignerUpper}
                                  </div>
                                </div>

                                <div
                                  className="col-auto p-0"
                                  style={{
                                    color: PRIMARY_COLOR,
                                    fontWeight: "600",
                                    fontSize: "30px",
                                    lineHeight: "1",
                                  }}
                                >
                                  {countObj?.alignerUpper +
                                    countObj?.alignerLower}
                                </div>

                                <div
                                  className="col-auto p-0 position-relative"
                                  style={{}}
                                >
                                  <img
                                    className=""
                                    src={LowerTeethImage}
                                    alt="upper teeth"
                                    style={{
                                      // height: '30px',
                                      width: "38px",
                                    }}
                                  />
                                  <div
                                    className="position-absolute d-flex align-items-start justify-content-center"
                                    style={{
                                      top: "0",
                                      width: "100%",
                                      left: "0",
                                      fontSize: "12.5px",
                                      color: DESCRIPTION_COLOR,
                                    }}
                                  >
                                    {countObj?.alignerLower}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-auto p-0">
                            <div
                              className="d-flex flex-column align-items-center justify-content-start"
                              style={{
                                gap: "9px",
                              }}
                            >
                              <div
                                className="text-center"
                                style={{
                                  fontSize: "12px",
                                  color: PRIMARY_COLOR,
                                }}
                              >
                                Retainers
                              </div>

                              <div
                                className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                style={{
                                  gap: "7px",
                                }}
                              >
                                <div
                                  className="col-auto p-0 position-relative"
                                  style={{}}
                                >
                                  <img
                                    className=""
                                    src={UpperTeethImage}
                                    alt="upper teeth"
                                    style={{
                                      // height: '35px',
                                      width: "38px",
                                    }}
                                  />
                                  <div
                                    className="position-absolute d-flex align-items-end justify-content-center"
                                    style={{
                                      bottom: "0",
                                      width: "100%",
                                      left: "0",
                                      fontSize: "12.5px",
                                      color: DESCRIPTION_COLOR,
                                    }}
                                  >
                                    {countObj?.retainerUpper}
                                  </div>
                                </div>

                                <div
                                  className="col-auto p-0"
                                  style={{
                                    color: PRIMARY_COLOR,
                                    fontWeight: "600",
                                    fontSize: "30px",
                                    lineHeight: "1",
                                  }}
                                >
                                  {countObj?.retainerUpper +
                                    countObj?.retainerLower}
                                </div>

                                <div
                                  className="col-auto p-0 position-relative"
                                  style={{}}
                                >
                                  <img
                                    className=""
                                    src={LowerTeethImage}
                                    alt="upper teeth"
                                    style={{
                                      // height: '30px',
                                      width: "38px",
                                    }}
                                  />
                                  <div
                                    className="position-absolute d-flex align-items-start justify-content-center"
                                    style={{
                                      top: "0",
                                      width: "100%",
                                      left: "0",
                                      fontSize: "12.5px",
                                      color: DESCRIPTION_COLOR,
                                    }}
                                  >
                                    {countObj?.retainerLower}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* LABELS RIGHT */}
                      <div className="col-auto p-0">
                        <div
                          className=""
                          style={{
                            height: "129px",
                            paddingBottom: "15px",
                          }}
                        >
                          <div className="row mx-auto flex-column justify-content-end h-100">
                            <div className="col-auto p-0">
                              <div
                                className="row mx-auto flex-column align-items-center justify-content-center"
                                style={{
                                  fontSize: "7px",
                                  color: DESCRIPTION_COLOR,
                                  gap: "20.5px",
                                }}
                              >
                                <div className="col-auto p-0" style={{}}>
                                  UPPER
                                </div>
                                <div className="col-auto p-0" style={{}}>
                                  TOTAL
                                </div>
                                <div className="col-auto p-0" style={{}}>
                                  LOWER
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* CENTER HEADING TEXT */}
              <div className="col-12 p-0">
                <div
                  className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                  style={{
                    textAlign: "center",
                    lineHeight: "1",
                    gap: "8px",
                  }}
                >
                  <div className="col-auto p-0">
                    <div
                      className=""
                      style={{
                        fontSize: "12px",
                        color: DESCRIPTION_COLOR,
                      }}
                    >
                      Status
                    </div>
                  </div>
                  <div className="col-auto p-0">
                    <div
                      className=""
                      style={{
                        fontSize: "16px",
                        color: PRIMARY_COLOR,
                        fontWeight: "600",
                      }}
                    >
                      {caseDetails?.current_status}
                    </div>
                  </div>
                </div>
              </div>
              {/* Case ID HEADING TEXT */}
              <div className="col-12 p-0">
                <div
                  className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                  style={{
                    textAlign: "center",
                    lineHeight: "1",
                    gap: "8px",
                  }}
                >
                  <div className="col-auto p-0">
                    <div
                      className=""
                      style={{
                        fontSize: "12px",
                        color: DESCRIPTION_COLOR,
                      }}
                    >
                      ID
                    </div>
                  </div>
                  <div className="col-auto p-0">
                    <div
                      className=""
                      style={{
                        fontSize: "16px",
                        color: PRIMARY_COLOR,
                        fontWeight: "600",
                      }}
                    >
                      {caseDetails?.case_id}
                    </div>
                  </div>
                </div>
              </div>
              {/* BUTTON ROW */}
              <div className="col-12 p-0">
                <div
                  className="row w-100 mx-auto justify-content-center align-items-center"
                  style={{
                    gap: "8px",
                  }}
                >
                  <div className="col-auto p-0">
                    <Link
                      className="btn"
                      style={{
                        border: "none",
                        backgroundColor: TERTIARY_COLOR,
                        color: PRIMARY_COLOR,
                        fontWeight: "400",
                        fontSize: "10px",
                        borderRadius: "20px",
                        minWidth: "75px",
                        padding: "8px 4px",
                        lineHeight: "1",
                      }}
                      to={"/discussion"}
                    >
                      Chat
                    </Link>
                  </div>

                  {/* <div className="col-auto p-0">
                    <Link
                      className="btn"
                      style={{
                        border: "none",
                        backgroundColor: TERTIARY_COLOR,
                        color: PRIMARY_COLOR,
                        fontWeight: "400",
                        fontSize: "10px",
                        borderRadius: "20px",
                        minWidth: "75px",
                        padding: "8px 4px",
                        lineHeight: "1",
                      }}
                    >
                      Comments
                    </Link>
                  </div> */}

                  <div className="col-auto p-0">
                    <Link
                      className="btn"
                      style={{
                        border: "none",
                        backgroundColor: TERTIARY_COLOR,
                        color: PRIMARY_COLOR,
                        fontWeight: "400",
                        fontSize: "10px",
                        borderRadius: "20px",
                        minWidth: "75px",
                        padding: "8px 4px",
                        lineHeight: "1",
                      }}
                      to={"/cases"}
                    >
                      Previous Cases
                    </Link>
                  </div>
                </div>
              </div>
              {/* Wearing History */}
              {/* <div className="col-12 p-0">
                <div
                  className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                  style={{
                    gap: "18px",
                  }}
                >
                  <div className="col-auto p-0">
                    <div
                      className="text-center"
                      style={{
                        fontSize: "12px",
                        color: PRIMARY_COLOR,
                        fontWeight: "normal",
                        lineHeight: "1",
                      }}
                    >
                      Alignment Wearing History
                    </div>
                  </div>

                  <div
                    className={`${
                      screenWidth > 620 ? "col-8" : "col-auto"
                    } p-0`}
                  >
                    <div
                      className="w-100 d-flex flex-column justify-content-start"
                      style={{
                        minHeight: "125px",
                        paddingInline: "8px",
                      }}
                    >
                      <div
                        className="row w-100 mx-auto flex-column justify-content-between align-items-start"
                        style={{
                          color: "rgb(110, 121, 125)",
                          gap: "22px",
                        }}
                      >
                        {alignmentHistoryData.map((item, index) => {
                          let IconComponent = item?.icon || "";

                          return (
                            <div className="col-12 p-0" key={index}>
                              <div
                                className={`row w-100 mx-auto align-items-center justify-content-${
                                  screenWidth > 620 ? "between" : "start"
                                }`}
                                style={{
                                  gap: "7px",
                                }}
                              >
                                <div className="d-flex col-auto px-0 gap-md-4 gap-2">
                                  <div className="col-auto p-0 position-relative">
                                    {index !==
                                      alignmentHistoryData.length - 1 && (
                                      <div
                                        className="position-absolute"
                                        style={{
                                          width: "0.8px",
                                          height: "20px",
                                          backgroundColor: "rgb(176, 176, 176)",
                                          bottom: "0",
                                          left: "47%",
                                          transform:
                                            "translateY(112%) translateX(0%)",
                                        }}
                                      ></div>
                                    )}
                                    <div
                                      className="d-flex align-items-center justify-content-center"
                                      style={{
                                        // height: '21px',
                                        width: "21px",
                                      }}
                                    >
                                      <IconComponent style={item?.iconStyle} />
                                    </div>
                                  </div>
                                  <div className="col-auto p-0">
                                    <div
                                      className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                      style={{
                                        lineHeight: "1",
                                        minWidth: "45px",
                                        gap: "3px",
                                        color: TEXT_COLOR,
                                      }}
                                    >
                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "12px",
                                          }}
                                        >
                                          {item?.date}
                                        </div>
                                      </div>
                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "8.5px",
                                          }}
                                        >
                                          {item?.time}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`${
                                    screenWidth > 620 ? "col-auto" : "col"
                                  } p-0`}
                                >
                                  <div
                                    className="row w-100 mx-auto flex-column align-items-start justify-content-center"
                                    style={{
                                      lineHeight: "1",
                                      // minWidth: '80px',
                                      gap: "3px",
                                      // textDecoration: 'underline'
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "12px",
                                          // textDecoration: 'underline',
                                          // textDecorationThickness: '0.06em'
                                        }}
                                      >
                                        {item?.title}
                                      </div>
                                    </div>
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "8.5px",
                                          // textDecoration: 'underline',
                                          // textDecorationThickness: '0.1em'
                                        }}
                                      >
                                        Status: {item?.status}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* Case History */}
              {/* <div className="col-12 col-sm-auto p-0">
                <div
                  className="row w-100 mx-auto flex-column align-items-center justify-content-start"
                  style={{
                    gap: "18px",
                    paddingTop: "5px",
                  }}
                >
                  <div className="col-auto p-0">
                    <div
                      className="text-center"
                      style={{
                        fontSize: "12px",
                        color: PRIMARY_COLOR,
                        fontWeight: "normal",
                        lineHeight: "1",
                      }}
                    >
                      Case History
                    </div>
                  </div>

                  <div className="col-12 p-0">
                    <div
                      className="row w-100 mx-auto align-items-center jusitfy-content-start"
                      style={{
                        gap: "18px",
                        minHeight: "70px",
                      }}
                    >
                      <div className="col-12 p-0">
                        <div
                          className="row w-100 mx-auto align-items-center justify-content-center"
                          style={
                            {
                              // backgroundColor: 'rgb(255, 255, 255)',
                              // borderRadius: '15px',
                              // padding: '6px',
                            }
                          }
                        >
                          <div
                            className={`${
                              screenWidth > 620 ? "col-10" : "col-auto"
                            } p-0`}
                          >
                            <div
                              className={`row w-100 mx-auto align-items-start justify-content-${
                                screenWidth > 620 ? "between" : "start"
                              }`}
                              style={{
                                gap: screenWidth >= 576 ? "16px" : "7px",
                                flexWrap: "nowrap",
                              }}
                            >
                              <div className="d-flex col-auto p-0 gap-2">
                                <div className="col-auto p-0">
                                  <div
                                    className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                    style={{
                                      gap: "6px",
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          width: "37px",
                                        }}
                                      >
                                        <ClockIcon
                                          style={{
                                            overflow: "visible",
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          lineHeight: "1",
                                          fontSize: "10px",
                                          color: DESCRIPTION_COLOR,
                                          fontWeight: "normal",
                                        }}
                                      >
                                        09:30 AM
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-auto p-0">
                                  <div
                                    className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                    style={{
                                      lineHeight: "1",
                                      minWidth: "45px",
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "22px",
                                          color: PRIMARY_COLOR,
                                          fontWeight: "normal",
                                        }}
                                      >
                                        25
                                      </div>
                                    </div>
                                    <div
                                      className="col-auto p-0"
                                      style={{
                                        marginTop: "2.5px",
                                      }}
                                    >
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "14.5px",
                                          color: "#000000",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        FEB
                                      </div>
                                    </div>
                                    <div
                                      className="col-auto p-0"
                                      style={{
                                        marginTop: "1px",
                                      }}
                                    >
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "10px",
                                          color: DESCRIPTION_COLOR,
                                          fontWeight: "normal",
                                        }}
                                      >
                                        2024
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-auto p-0">
                                <div
                                  className="row w-100 mx-auto flex-column align-items-start justify-content-start"
                                  style={{
                                    gap: "8px",
                                    paddingTop: "2px",
                                    minWidth:
                                      screenWidth >= 576 ? "142px" : "125px",
                                    maxWidth:
                                      screenWidth >= 576 ? "160px" : "125px",
                                    paddingLeft:
                                      screenWidth >= 576 ? "18px" : "0",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className="row w-100 mx-auto flex-column align-items-start"
                                      style={{
                                        lineHeight: "1",
                                        fontWeight: "normal",
                                        gap: "0.5px",
                                      }}
                                    >
                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "9px",
                                            color: DESCRIPTION_COLOR,
                                          }}
                                        >
                                          Treatment
                                        </div>
                                      </div>

                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "10px",
                                            color: PRIMARY_COLOR,
                                            minWidth: "125px",
                                            maxWidth: "150px",
                                          }}
                                        >
                                          Root Canal Treatment
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-auto p-0">
                                    <div
                                      className="row w-100 mx-auto flex-column align-items-start"
                                      style={{
                                        lineHeight: "1",
                                        fontWeight: "normal",
                                        gap: "0.5px",
                                      }}
                                    >
                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "9px",
                                            color: DESCRIPTION_COLOR,
                                          }}
                                        >
                                          Doctor
                                        </div>
                                      </div>

                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "10px",
                                            color: PRIMARY_COLOR,
                                            minWidth: "125px",
                                            maxWidth: "150px",
                                          }}
                                        >
                                          Adam Jacob - Dentora
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 p-0">
                        <hr
                          className="m-0 mx-auto"
                          style={{
                            width: "100%",
                            maxWidth: screenWidth >= 576 ? "320px" : "255px",
                            padding: "0 15px",
                          }}
                        />
                      </div>

                      <div className="col-12 p-0">
                        <div
                          className="row w-100 mx-auto align-items-center justify-content-center"
                          style={
                            {
                              // backgroundColor: 'rgb(255, 255, 255)',
                              // borderRadius: '15px',
                              // padding: '6px',
                            }
                          }
                        >
                          <div
                            className={`${
                              screenWidth > 620 ? "col-10" : "col-auto"
                            } p-0`}
                          >
                            <div
                              className={`row w-100 mx-auto align-items-start justify-content-${
                                screenWidth > 620 ? "between" : "start"
                              }`}
                              style={{
                                gap: screenWidth >= 576 ? "16px" : "7px",
                                flexWrap: "nowrap",
                              }}
                            >
                              <div className="d-flex col-auto p-0 gap-2">
                                <div className="col-auto p-0">
                                  <div
                                    className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                    style={{
                                      gap: "6px",
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          width: "37px",
                                        }}
                                      >
                                        <ClockIcon
                                          style={{
                                            overflow: "visible",
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          lineHeight: "1",
                                          fontSize: "10px",
                                          color: DESCRIPTION_COLOR,
                                          fontWeight: "normal",
                                        }}
                                      >
                                        09:30 AM
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-auto p-0">
                                  <div
                                    className="row w-100 mx-auto flex-column align-items-center justify-content-center"
                                    style={{
                                      lineHeight: "1",
                                      minWidth: "45px",
                                    }}
                                  >
                                    <div className="col-auto p-0">
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "22px",
                                          color: PRIMARY_COLOR,
                                          fontWeight: "normal",
                                        }}
                                      >
                                        25
                                      </div>
                                    </div>
                                    <div
                                      className="col-auto p-0"
                                      style={{
                                        marginTop: "2.5px",
                                      }}
                                    >
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "14.5px",
                                          color: "#000000",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        FEB
                                      </div>
                                    </div>
                                    <div
                                      className="col-auto p-0"
                                      style={{
                                        marginTop: "1px",
                                      }}
                                    >
                                      <div
                                        className=""
                                        style={{
                                          fontSize: "10px",
                                          color: DESCRIPTION_COLOR,
                                          fontWeight: "normal",
                                        }}
                                      >
                                        2024
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-auto p-0">
                                <div
                                  className="row w-100 mx-auto flex-column align-items-start justify-content-start"
                                  style={{
                                    gap: "8px",
                                    paddingTop: "2px",
                                    minWidth:
                                      screenWidth >= 576 ? "142px" : "125px",
                                    maxWidth:
                                      screenWidth >= 576 ? "160px" : "125px",
                                    paddingLeft:
                                      screenWidth >= 576 ? "18px" : "0",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className="row w-100 mx-auto flex-column align-items-start"
                                      style={{
                                        lineHeight: "1",
                                        fontWeight: "normal",
                                        gap: "0.5px",
                                      }}
                                    >
                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "9px",
                                            color: DESCRIPTION_COLOR,
                                          }}
                                        >
                                          Treatment
                                        </div>
                                      </div>

                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "10px",
                                            color: PRIMARY_COLOR,
                                            minWidth: "125px",
                                            maxWidth: "150px",
                                          }}
                                        >
                                          Root Canal Treatment
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-auto p-0">
                                    <div
                                      className="row w-100 mx-auto flex-column align-items-start"
                                      style={{
                                        lineHeight: "1",
                                        fontWeight: "normal",
                                        gap: "0.5px",
                                      }}
                                    >
                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "9px",
                                            color: DESCRIPTION_COLOR,
                                          }}
                                        >
                                          Doctor
                                        </div>
                                      </div>

                                      <div className="col-auto p-0">
                                        <div
                                          className=""
                                          style={{
                                            fontSize: "10px",
                                            color: PRIMARY_COLOR,
                                            minWidth: "125px",
                                            maxWidth: "150px",
                                          }}
                                        >
                                          Adam Jacob - Dentora
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TreatmentPlanScreen;
